<template>
  <div class="form-input-complex">

    <template v-if="isExclusive">
      <el-row>
        <el-col :span="8">
          <el-select
             v-model="exclusive.value"
            :style="{ width: '22em' }"
            :placeholder="placeholder"
            :disabled="disabled"
            :clearable="clearable"
            :filterable="true"
            :allow-create="true"
            @change="updateExclusive">
            <el-option
               v-for="option in exclusive.options"
              :label="option.name"
              :value="option.id"
              :key="option.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="24">
          <div class="el-form-item__help">
            <p>{{ $t('label.custom_input_allowed') }}</p>
          </div>
        </el-col>

      </el-row>
    </template>

    <tempate v-else>
      <el-row>
        <el-col :span="8">
          <el-select
             v-model="select.value"
            :style="{ width: '22em' }"
            :placeholder="placeholder"
            :disabled="disabled"
            :clearable="clearable"
            @change="updateSelect">
            <el-option
               v-for="option in select.options"
              :label="option.name"
              :value="option.id"
              :key="option.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-input
            v-model="simple.value"
            :placeholder="$t('label.comment')"
            :disabled="disabled"
            @change="updateSimple">
          </el-input>
        </el-col>
        <el-col :span="24" v-if="input.description">
          <div class="el-form-item__help">
            <p>{{ input.description }}</p>
          </div>
        </el-col>
      </el-row>
    </tempate>

  </div>
</template>

<script>
import { first, find, isNil } from 'lodash';

export default {
  name: 'form-input-complex',
  props: {
    input: {
      type: Object,
      required: true,
      default: null,
    },
    value: {
      required: true,
      default: null,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    behavior: {
      type: String,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      exclusive: {
        id: null,
        code: null,
        options: null,
        value: null,
      },
      select: {
        id: null,
        code: null,
        options: null,
        value: null,
      },
      simple: {
        id: null,
        code: null,
        value: null,
      },
    };
  },
  computed: {
    isExclusive() {
      return this.behavior === 'exclusive';
    },
  },
  methods: {
    updateSimple() {
      this.$emit('set:value', {
        code: this.simple.code,
        data: {
          id: this.simple.id,
          value: this.simple.value,
        },
      });
    },
    updateSelect() {
      this.$emit('set:value', {
        code: this.select.code,
        data: {
          id: this.select.id,
          value: this.select.value,
        },
      });
    },
    setExclusive(code) {
      this.$emit('set:value', {
        code,
        data: {
          id: this.exclusive.id,
          value: this.exclusive.value,
        },
      });
    },
    clearOposite(code) {
      this.$emit('set:value', {
        code,
        data: {
          id: this.exclusive.id,
          value: null,
        },
      });
    },
    updateExclusive(value) {
      const select = this.input.SubCategories.find(item => item.field_type === 'select');
      const simple = this.input.SubCategories.find(item => item.field_type === 'simple');

      const selected = find(this.exclusive.options, item => item.id === value);
      const input = selected ? select : simple;
      const oposite = selected ? simple : select;

      this.exclusive.id = input.id;
      this.exclusive.code = input.code;

      this.setExclusive(input.code);
      this.clearOposite(oposite.code);
    },
  },
  created() {
    const select = this.input.SubCategories.find(item => item.field_type === 'select');
    const simple = this.input.SubCategories.find(item => item.field_type === 'simple');

    const selected = first(select.selected);

    if (this.isExclusive) {
      const input = selected ? select : simple;
      const value = selected ? first(select.selected) : simple.value;

      this.exclusive.id = input.id;
      this.exclusive.code = input.code;
      this.exclusive.options = select.SubCategories;
      this.exclusive.value = value;

      this.setExclusive(input.code);
    } else {
      if (!isNil(select)) {
        this.select.id = select.id;
        this.select.code = select.code;
        this.select.options = select.SubCategories;
        this.select.value = first(select.selected);
        this.updateSelect();
      }

      if (!isNil(simple)) {
        this.simple.id = simple.id;
        this.simple.code = simple.code;
        this.simple.value = simple.value;
        this.updateSimple();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
  .form-input-complex >>> .el-row {
    margin-bottom: 0.75em;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/shared/category-questionnaire/form-input/cmpt-form-input-complex.vue